import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { Employee, PaginatedResponse, ApiResponse } from '@com.maessa.payroll.frontend/models';

export interface EmployeeFilters {
  site_id?: number;
  team_id?: number;
  active?: boolean;
  search?: string;
  page?: number;
  per_page?: number;
}

export interface EmployeePayload {
  employee_number: string;
  first_name: string;
  last_name: string;
  specialty_id: number | null;
  site_id: number;
  active: boolean;
}

@Injectable({ providedIn: 'root' })
export class EmployeeApiService extends BaseApiService {
  getEmployees(filters?: EmployeeFilters): Observable<PaginatedResponse<Employee>> {
    const params = this.buildParams((filters ?? {}) as Record<string, unknown>);
    return this.get<PaginatedResponse<Employee>>(`${this.baseUrl}/employees`, params);
  }

  getEmployee(id: number): Observable<ApiResponse<Employee>> {
    return this.get<ApiResponse<Employee>>(`${this.baseUrl}/employees/${id}`);
  }

  createEmployee(payload: EmployeePayload): Observable<ApiResponse<Employee>> {
    return this.post<ApiResponse<Employee>>(`${this.baseUrl}/employees`, payload);
  }

  updateEmployee(id: number, payload: Partial<EmployeePayload>): Observable<ApiResponse<Employee>> {
    return this.put<ApiResponse<Employee>>(`${this.baseUrl}/employees/${id}`, payload);
  }

  deleteEmployee(id: number): Observable<void> {
    return this.delete<void>(`${this.baseUrl}/employees/${id}`);
  }
}
